import React from "react";
import { Tokens } from "../../services/Tokens";
import imageService from "../../services/images";
import { logger } from "../../services/logger";
import { Button, Skeleton, Stack } from "@mui/material";
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { SnackBarContext } from "../../Context/SnackbarProvider";
import TranslationContent from "../../Translations/TranslationContent";


const ObservationImage = ({ imageId, images, updateImages, openLargeImage, inspection, updateInspection, observationId }) => {
  const [imageState, setImageState] = React.useState("loading");
  const [imageData, setImageData] = React.useState("");
  const { addAlert } = React.useContext(SnackBarContext);

  const fetchData = React.useRef(true);
  React.useEffect(() => {
    if(fetchData.current) {
      fetchData.current = false;
    
    let localImage = images.find(image => image.id === imageId)
    if(localImage) {
      setImageData(localImage.data);
      setImageState("fetched")
    }
    else {
      Tokens().then((tokens) => {
        imageService
        .getInspectionImage(inspection.id, imageId, tokens.accessToken, tokens.idToken)
        .then(response => {
          logger(response);
          updateImages(response, "add");
          setImageState("fetched")
          setImageData(response.data);
        })
        .catch(error => {
          logger(error);
          setImageState("error")
        })
      })
      .catch(error => {
        logger(error);
        addAlert({message: "snackbarSessionExpired", type: "error"});
        setImageState("error")
      })
    
  }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  const deleteImage = () => {
    setImageState("deleting");
    Tokens().then((tokens) => {
      imageService
      .deleteObservationImage(inspection.id, imageId, observationId, tokens.accessToken, tokens.idToken)
      .then(response => {
        logger(response);
        let updatedInspection = {...inspection};
        updatedInspection.otherObservations.observations = updatedInspection.otherObservations.observations.map(observation => {
          if(observation.id === observationId) {
            observation.images = observation.images.filter(image => image !== imageId)
            return observation;
          }
          else return observation;
        });
        updateInspection(updatedInspection, "imageUpdate")
        updateImages(imageId, "remove");
        setImageState("");
        addAlert({message: "snackbarImageDeleteSuccessful", type: "success"});
      })
      .catch(error => {
        logger(error);
        addAlert({message: "snackbarImageDeleteFailed", type: "error"});
        setImageState("fetched");
      })
    })
    .catch(error => {
      logger(error);
      addAlert({message: "snackbarSessionExpired", type: "error"});
      setImageState("fetched");
    })
  }

  switch(imageState) {
    case "loading":
      return <Skeleton variant="retangular" width={125} height={125} />;
    case "fetched":
      return (
      <Stack sx={{ width: "100%", textAlign: "center", alignContent: "center", justifyContent: "center", display: "inline-grid"}}>
        <img src={imageData} onClick={() => openLargeImage(imageData)} alt="Inspector's observation's visual content" key={`Observation image - ${imageId}`} height={125} width={125} style={{border: "1px solid", cursor: "zoom-in"}}/>
        <Button color="error" size="small" onClick={() => deleteImage()}><TranslationContent contentID="delete" /></Button>
      </Stack>
      )
    case "error":
      return <BrokenImageIcon color="error" sx={{width: 125, height: 125}} />;
    case "deleting":
      return (
        <Stack sx={{ width: "100%", textAlign: "center", alignContent: "center", justifyContent: "center", display: "inline-grid"}} >
          <Skeleton variant="retangular" width={125} height={125} sx={{ bgcolor: "darkred"}} />
          <Button color="error" size="small" disabled><TranslationContent contentID="delete" /></Button>
        </Stack>
      );
    default: 
      return null;
  }
}

export default ObservationImage;